import Vue from 'vue';
import Vuex from 'vuex';

import categories from './modules/categories';
import collections from './modules/collections';
import decors from './modules/decors';
import users from './modules/users';
import translations from './modules/translations';
import tags from './modules/tags';
import selections from './modules/selections';
import products from './modules/products';
import packages from './modules/packages';
import languages from './modules/languages';
import ranges from './modules/ranges';
import regions from "./modules/regions";
import exports from "./modules/exports";
import imports from "./modules/imports";

Vue.use(Vuex);
// const debug = process.env.NODE_ENV !== "production";

const store = new Vuex.Store({
  modules: {
    categories,
    collections,
    decors,
    languages,
    packages,
    products,
    ranges,
    selections,
    tags,
    translations,
    users,
    regions,
    exports,
    imports
  },
  strict: false,
});
export default store;
